import React from "react";
import "./LineSplit.style.scss";
function LineSplit({ isGreen, isShort, noMarginBottom }) {
  return (
    <div
      className={
        "ctn-line-split " +
        (isGreen ? "bg-green " : "") +
        (isShort ? "short-line-split " : "") +
        (noMarginBottom ? "no-margin-bottom " : "")
      }
    ></div>
  );
}
export default LineSplit;
